/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-09-22
 * @brief EHP 사용자 관리 개발
 *
 ********************************************************************/
import React, { useState } from "react";
import NoUserView from "./NoUserView";
import UserView from "./UserView";
import UserTree from "./UserTree";
//
/**
 * @brief EHP 사용자 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
export default function UserMain(props) {
    // tree 선택 시 이동 
    const [selTree, setSelTree] = useState({
        company: { companyId: "", companyName: "" },
        reload: false
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(UserTree, { setPopWin: props.setPopWin, selTree: selTree, setSelTree: setSelTree }),
        (selTree.company.companyId.length > 0) ?
            React.createElement(UserView, { setPopWin: props.setPopWin, selTree: selTree, setSelTree: setSelTree })
            :
                React.createElement(NoUserView, { setPopWin: props.setPopWin })));
}
